'use client';

import { styled } from '../../../styles';
import { Typography } from '../../Typography';

export const DefaultCellContainer = styled.div(() => ({
  minWidth: 0,
}));

export const CellValue = styled(Typography)(() => ({
  minWidth: 0,
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const CellValueMargin = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
